<template>
    <div class="api-error-logs">
        <!-- Header -->
        <div class="dashboard-header mb-4">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h5 class="dashboard-title text-white">
                        <i class="fas fa-exclamation-triangle mr-2"></i>
                        Logs de Erros da API
                    </h5>
                </div>
                <div class="col-md-6 text-right">
                    <button
                        class="btn btn-danger btn-sm mr-3"
                        @click="clearAllLogs"
                        title="Limpar todos os logs"
                    >
                        <i class="fas fa-trash mr-1"></i>
                        Limpar Logs
                    </button>
                    <div class="last-update d-inline-block">
                        <small class="text-white">
                            <i class="fas fa-clock mr-1"></i>
                            Última atualização: {{ formatDateTime(new Date()) }}
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabela de logs -->
        <div class="logs-table">
            <div class="card shadow-sm border-0">
                <div class="card-header bg-gradient-dark text-white">
                    <h6 class="card-title mb-0">
                        <i class="fas fa-list mr-2"></i>
                        Lista de Erros
                    </h6>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <base-crud
                            ref="baseCrudTable"
                            :table="table"
                            :extra="extra"
                            :columns="columns"
                            :options="options"
                            :endPoint="endPoint"
                            :enableAdd="false"
                            :enableEdit="false"
                            :enableDelete="false"
                            :enableView="false"
                            :dataForm="dataForm"
                            @viewDetails="viewDetails"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de detalhes -->
        <ModalDetails
            :modal-visible="modalVisible"
            :selected-log="selectedLog"
            @close="fecharModal"
        />
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud"
import ModalDetails from "./ModalDetails.vue"
import moment from 'moment'

export default {
    name: 'ApiErrorLogIndex',

    components: {
        BaseCrud,
        ModalDetails
    },

    data() {
        const apiUrl = this.$store.state.api

        return {
            modalVisible: false,
            selectedLog: null,

            extra: [
                {
                    id: 1,
                    label: "",
                    class: "fas fa-eye btn btn-crud view",
                    title: "Ver detalhes do erro",
                    name: "viewDetails",
                    icon: "btn btn-crud view",
                }
            ],

            table: "apiErrorLogsTable",
            columns: [
                "id",
                "status_code",
                "error_message",
                "method",
                "url",
                "user_id",
                "created_at",
                "actions"
            ],
            endPoint: "api-error-logs/",
            dataForm: {},

            options: {
                headings: {
                    id: "ID",
                    status_code: "Status HTTP",
                    error_message: "Mensagem",
                    method: "Método",
                    url: "URL",
                    user_id: "Usuário",
                    created_at: "Data",
                    actions: "Ações"
                },
                sortable: ["id", "status_code", "created_at"],
                filterable: ["id", "status_code", "error_message", "method", "url", "user_id"],
                filterByColumn: true,
                orderByDesc: 'created_at',
                listColumns: {
                    status_code: [
                        {id: 400, text: '400 - Bad Request'},
                        {id: 401, text: '401 - Unauthorized'},
                        {id: 403, text: '403 - Forbidden'},
                        {id: 404, text: '404 - Not Found'},
                        {id: 422, text: '422 - Validation Error'},
                        {id: 500, text: '500 - Internal Server Error'},
                        {id: 503, text: '503 - Service Unavailable'}
                    ],
                    method: [
                        {id: 'GET', text: 'GET'},
                        {id: 'POST', text: 'POST'},
                        {id: 'PUT', text: 'PUT'},
                        {id: 'PATCH', text: 'PATCH'},
                        {id: 'DELETE', text: 'DELETE'}
                    ]
                },
                templates: {
                    status_code: function (h, row) {
                        let badgeClass = ''
                        if (row.status_code >= 500) {
                            badgeClass = 'danger'
                        } else if (row.status_code >= 400) {
                            badgeClass = 'warning'
                        }

                        return h('span', {
                            class: `badge badge-${badgeClass}`,
                        }, row.status_code)
                    },
                    error_message: function (h, row) {
                        const message = row.error_message || 'Erro desconhecido'
                        const truncated = message.length > 50
                            ? message.substring(0, 50) + '...'
                            : message

                        return h('span', {
                            attrs: {
                                title: message
                            }
                        }, truncated)
                    },
                    method: function (h, row) {
                        const methods = {
                            'GET': 'info',
                            'POST': 'success',
                            'PUT': 'primary',
                            'PATCH': 'warning',
                            'DELETE': 'danger'
                        }
                        const badgeClass = methods[row.method] || 'secondary'

                        return h('span', {
                            class: `badge badge-${badgeClass}`,
                        }, row.method)
                    },
                    url: function (h, row) {
                        const fullUrl = row.url || '-'
                        const url = fullUrl.replace(apiUrl, '')
                        const truncated = url.length > 40
                            ? url.substring(0, 40) + '...'
                            : url

                        return h('span', {
                            attrs: {
                                title: url
                            }
                        }, truncated)
                    },
                    created_at: function (h, row) {
                        return h('span', moment(row.created_at).format('DD/MM/YYYY HH:mm:ss'))
                    }
                }
            }
        }
    },

    methods: {
        formatDateTime(date) {
            if (!date) return '-'
            return moment(date).format('DD/MM/YYYY HH:mm:ss')
        },

        viewDetails(data) {
            // BaseCrud envia {props, row, index} - precisamos do row
            const log = data.row || data
            this.selectedLog = log
            this.modalVisible = true
        },

        fecharModal() {
            this.modalVisible = false
            this.selectedLog = null
        },

        clearAllLogs() {
            const self = this
            swal({
                title: 'Tem certeza?',
                text: "Todos os logs de erro serão removidos permanentemente!",
                type: 'warning',
                buttons: {
                    cancel: {
                        text: "Cancelar",
                        value: null,
                        visible: true,
                        closeModal: true,
                    },
                    confirm: {
                        text: "Sim, limpar tudo!",
                        value: true,
                        visible: true,
                        closeModal: true
                    }
                }
            }).then((willDelete) => {
                if (willDelete) {
                    self.$http.delete(self.$store.state.api + 'api-error-logs-truncate')
                        .then(() => {
                            swal('Sucesso!', 'Todos os logs foram removidos.', 'success')
                            // Recarrega a tabela
                            self.$refs.baseCrudTable.$refs.table.refresh()
                        })
                        .catch((error) => {
                            swal('Erro!', 'Não foi possível limpar os logs.', 'error')
                            console.error(error)
                        })
                }
            })
        }
    }
}
</script>

<style scoped>
.dashboard-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
}

.dashboard-title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
}

.last-update {
    font-size: 0.9rem;
    opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/components/ApiErrorLog/Index.vue